module.exports = __webpack_public_path__ + "static/media/portoEduc_Bn_Cursos_Online.28abf805.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portoEduc_Bn_Cursos_Online.jpg
// module id = 1459
// module chunks = 0